






































































import iwOrderSummary from "../components/Payment/OrderSummary.vue";
import iwPaymentMethod from "../components/Payment/PaymentMethod.vue";
import iwTermsAgreement from "../components/Payment/TermsAgreement.vue";
import iwDeliveryNoticeCallout from "@/optimizedEncoding/components/DeliveryNoticeCallout.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import missingCustomerNameMixin from "@/shared/mixins/missingCustomerName";
import { mapClassifiedTypeToGA4, pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { mapActions, mapGetters, mapState } from "vuex";
import thor from "@sl/thor";

export default missingCustomerNameMixin.extend({
    components: {
        iwOrderSummary: iwOrderSummary,
        iwPaymentMethod: iwPaymentMethod,
        iwTermsAgreement: iwTermsAgreement,
        iwDeliveryNoticeCallout: iwDeliveryNoticeCallout,
        iwButtonLoading: iwButtonLoading
    },

    props: {
        action: {
            type:String,
            required: false,
            default: "PUBLICATION"
        }
    },

    data: function() {
        return {
            isButtonDisabledInternal: false as boolean,
            isCheckoutStarted: false as boolean
        };
    },

    computed: {
        ...mapState("OrdersModule", ["currentOrder", "transactions"]),
        ...mapState("AgreementModule", ["termsAndConditions", "immediatePublication"]),
        ...mapGetters({
            getStep: "StepsWizard/getStep",
        }),
        paymentDeclined: function(): boolean {
            return !!this.$route.query.error;
        },
        shouldReload: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("shouldReload");
        },
        isButtonDisabled: function(): boolean {
            return this.isButtonDisabledInternal || !this.termsAndConditions || !this.immediatePublication || !this.transactions.initial?.paymentMethod;
        },
    },
    watch: {
        shouldReload: function(newValue: boolean) {
            if (newValue) {
                this.$emit("section-uncompleted");
            }
        }
    },
    created: function() {
        localStorage.removeItem("optimized");
        const orderId = this.$route.query.orderId as string;
        this.$store.commit("FormModule/addValueUI", { "path": "shouldReload", "value": false });

        if (orderId) {
            this.getOrderById({
                orderId: orderId,
                errorRoute: this.$route.name,
                pricingType: this.action
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
            });
        }
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_v2_step9_payment");
        window.addEventListener("pageshow", this.onPageShow);
    },

    beforeDestroy: function() {
        window.removeEventListener("pageshow", this.onPageShow);
    },

    methods: {
        // Browser-back from the PSP restores this page from bfcache as it was on click: boxes
        // checked, spinner running. Keep the pack, but untick the boxes (button disabled again).
        onPageShow: function(event: PageTransitionEvent): void {
            if (event.persisted) {
                this.isButtonDisabledInternal = false;
                this.$store.commit("AgreementModule/termsAndConditions", false);
                this.$store.commit("AgreementModule/immediatePublication", false);
            }
        },
        ...mapActions("OrdersModule", ["getOrderById", "createOrder", "createTransaction"]),
        ...mapActions({
            validateAndGoToNextStep: "FormModule/validateAndGoToNextStep",
            goToPreviousStep: "StepsWizard/previous",
        }),
        goToPayment: function(){
            // Backstop: the order (and therefore the Salesforce B2C log) is already created by
            // the ContactInformation step, so this guard only catches a name that went bad
            // afterwards. Checked before the in-flight flag is raised below, so nothing to reset.
            if (this.blockOnMissingCustomerName(this.goToPayment)) {
                return false;
            }

            // Disable + spin the button before the request so a double-click can't fire
            // multiple Worldline transactions; reset on the failure / no-redirect paths below.
            this.isButtonDisabledInternal = true;
            // Back from the PSP (bfcache keeps this flag): the order's checkout is still pending and
            // the backend would reject a new transaction (ORDER_PAYMENT_PENDING), so re-create the
            // order for the same pack first.
            const paymentMethod = this.transactions.initial?.paymentMethod;
            const orderReady = this.isCheckoutStarted
                ? this.createOrder().then(() => {
                    this.$store.commit("OrdersModule/transactions/paymentMethod", paymentMethod);
                })
                : Promise.resolve();
            orderReady
                .then(() => this.createTransaction())
                .then(transaction => {
            
                    if (transaction.hostedCheckoutId) {
                        localStorage.setItem("hostedCheckoutId", transaction.hostedCheckoutId);
                        localStorage.setItem("optimized", "true");
                    }
                    this.classifiedDepositSubmit();

                    const redirectUrl = transaction.redirectUrl;
                    if (!redirectUrl) {
                        this.isButtonDisabledInternal = false;
                        return;
                    }
                    this.isCheckoutStarted = true;
                    window.location.href = redirectUrl;
                })
                .catch(error => {
                    this.isButtonDisabledInternal = false;
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                    console.error(error);
                });
            return false;
        },
        classifiedDepositSubmit: function() {
            thor.pushEvent(
                "classified_deposit_submit",
                {
                    "av_feature": "classified_deposit",
                    "av_user": {
                        "project": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "WantsToSell" : "WantsToRent",
                    },
                    "av_distribution_type_global": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
                    "av_estate_type_global": mapClassifiedTypeToGA4(this.$store.getters["FormModule/getValue"]("property.type")),
                    "av_distribution_subtype": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
                }
            );
        }
    },
});

